import { Component } from '@angular/core';

@Component({
  standalone: false,
	selector: 'app-footer',
	templateUrl: './app-footer.component.html',
})
export class AppFooterComponent {}
